import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';

const estadoSchema = z.enum([
  'borrador',
  'pendiente_aprobacion',
  'publicado',
  'pendiente_reapertura',
  'archivado',
]);

const tecnologiasSearchSchema = z.object({
  busqueda: z.string().trim().min(1).optional(),
  categoria: z.coerce.number().int().positive().optional(),
  // Normalize array-or-single from URL. `?estado=X` arrives as string,
  // `?estado=X&estado=Y` as array. Keep an array shape internally.
  estado: z
    .union([estadoSchema, z.array(estadoSchema)])
    .transform(v => (Array.isArray(v) ? v : [v]))
    .optional(),
  vista: z.enum(['grid', 'list']).optional(),
});

export type TecnologiasSearchParams = z.infer<typeof tecnologiasSearchSchema>;

export const Route = createFileRoute('/admin/recet/tecnologias/')({
  validateSearch: tecnologiasSearchSchema,
  pendingComponent: PageSkeleton,
});
